import loading from 'assets/img/loading.gif';

/**
 * This directive behaves just as `ng-src`,
 * but expects a value of the `File` type.
 *
 * @ngdoc directive
 */
class NgSrcBinaryDirective {
    constructor() {
        this.restrict = 'A';
        this.priority = 99;
    }

    get scope() {
        return {
            binary: '=ngSrcBinary',
        };
    }

    link(scope, element, attr) {
        attr.$attr['src'] = '';

        scope.$watch('binary', (file) => {
            if (typeof file === 'string') {
                attr.$set('src', file);
            } else if (file && file.type.split('/')[0] === 'image') {
                const reader = new FileReader();
                reader.onload = function(event) {
                    scope.dragover = false;
                    if (reader.readyState == FileReader.DONE) {
                        const base64 = event.target.result;
                        attr.$set('src', base64);
                    }
                };
                reader.readAsDataURL(file);
                attr.$set('src', loading);
            }
        });
    }

    static factory() {
        return new NgSrcBinaryDirective();
    }
}

// Explicit DI annotation for factory used in angular.directive registration
NgSrcBinaryDirective.factory.$inject = [];

export default NgSrcBinaryDirective.factory;
